import { formatDeliveryCountdown } from '~/domains/delivery/utils';
import { useCountdown } from '~/hooks/useCountdown';

type Props = {
  initialTime: number;
  isDot?: boolean;
};

const CountDown = ({ initialTime, isDot = false }: Props) => {
  const time = useCountdown(initialTime);

  const { d, h, m, s } = formatDeliveryCountdown(time);

  return (
    <>
      {!!d && d > 0 && `${addZeroUpperTen(d)}일 `}
      {!!h && h > 0 && `${addZeroUpperTen(h)}${isDot ? ' :' : '시간'} `}
      {!!m && m > 0 && `${addZeroUpperTen(m)}${isDot ? ' :' : '분'} `}
      {s > 0 && `${addZeroUpperTen(s)}${isDot ? '' : '초'}`}
    </>
  );
};

export default CountDown;

export function addZeroUpperTen(number: number) {
  return number >= 10 ? `${number}` : `0${number}`;
}
